import { Helmet } from 'react-helmet-async';
import { homeContent } from '@/content/home';
import { Hero } from '@/components/sections/Hero';
import { WhatCloaklingDoes } from '@/components/sections/WhatCloaklingDoes';
import { ValuePropGrid } from '@/components/sections/ValuePropGrid';
import { AudienceSplit } from '@/components/sections/AudienceSplit';
import { HowItWorks } from '@/components/sections/HowItWorks';
import { CloakedCleanRoomsTeaser } from '@/components/sections/CloakedCleanRoomsTeaser';
import { TrustDataHandling } from '@/components/sections/TrustDataHandling';
import { ClosingCTA } from '@/components/sections/ClosingCTA';

/**
 * Home (`/`) route — single-page launch.
 *
 * Section order matches the Pencil prototype frame "Home — Desktop" (Cyiqg).
 */
export function Home() {
  return (
    <>
      <Helmet>
        <title>Cloakling — Safely use ChatGPT on private documents</title>
        <meta
          name="description"
          content="Cloakling automatically finds sensitive information in PDFs, replaces it with realistic substitutes or redacts it, and gives you an AI-ready copy you can safely upload to ChatGPT, Claude, Gemini, or work tools."
        />
        <link rel="canonical" href="https://cloakling.com/" />
        <meta
          property="og:title"
          content="Cloakling — Safely use ChatGPT on private documents"
        />
        <meta
          property="og:description"
          content="Private document analysis for ChatGPT, Claude, and Gemini."
        />
        <meta property="og:url" content="https://cloakling.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <Hero content={homeContent.hero} />
      <WhatCloaklingDoes content={homeContent.mechanism} />
      <ValuePropGrid content={homeContent.valueProps} />
      <AudienceSplit content={homeContent.audiences} />
      <HowItWorks content={homeContent.howItWorks} />
      <CloakedCleanRoomsTeaser content={homeContent.cleanRooms} />
      <TrustDataHandling content={homeContent.trust} />
      <ClosingCTA content={homeContent.closingCta} />
    </>
  );
}
